import './growth.css';
export default function Growthhead({colclass, title}) {
    return(
        <section className="growth pb-0">
        <div className="container">
        <div className="row">
          <div className={`col-12  ${colclass}`}>
            <h2 className='title'>
              {title}
            </h2>
          </div>
          <div className={`col-12  ${colclass}`}>
            <h3>We believe in bridging the gap between knowing and doing.</h3>
            <p>
              Nobody appreciates the opportunity and the challenges of the Indian
              Retail market as well as we do.
            </p>
            <p>
              With more than <b>100 man years of experience</b>, we’ve been part of the
              India Retail experiment of global majors and Indian business houses-
              across a vast number of categories and formats,
            </p>
            <p>
              We’ve been involved as partners and employees, as executives and CXOs
              in every aspect of a retail business and every retail aspect of
              businesses.
            </p>
            <p>We’ve learnt from their successes and even more from their failures!</p>
          </div>
        </div>
        </div>
        </section>
    )
}